export const actionStage = {
  addActionStage: 'Create new stage',
  editActionStage: 'Edit stage',
  createdActionStage: 'New stage created',
  updatedActionStage: 'Stage updated',
  updatedIndexActionStage: 'Stage index updated',
  assignedNode: 'Step assigned to stage',
  manageActionStagesPara:
    'Edit, delete, add stages, and manage their order. Stages are used to group steps in the configuration template.',
  unassignedSteps: 'Unassigned steps',
  deleteStageActionTitle: 'Are you sure you want to delete the stage: { code }',
  deletedActionStageSuccess: 'Stage deleted',
  tooltip: {
    edit: 'Edit',
    delete: 'Delete',
    move: 'Drag to reorder',
  },
} as const
